import React, { PureComponent } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { FileThumb } from 'components/misc'
import { Span } from 'components/layout'
import { apiConfiguration, apiDownloadFile } from 'helpers/decorators/api'

const enhance = compose(apiConfiguration(), apiDownloadFile())

class ConfigurationFile extends PureComponent {
  static propTypes = {
    configuration: PropTypes.object.isRequired,
    formattedName: PropTypes.object,
    files: PropTypes.object.isRequired,
    configKey: PropTypes.string.isRequired,
    downloadedFile: PropTypes.string,
    inline: PropTypes.bool,
    isPublic: PropTypes.bool,
    autoDownload: PropTypes.bool,
    onDownloadFile: PropTypes.func,
    onGetConfigurationValue: PropTypes.func,
    organizationId: PropTypes.number
  }

  componentDidMount() {
    this.handleRequestDownload()
  }

  handleRequestDownload = () => {
    const { configKey, organizationId } = this.props

    this.props.onGetConfigurationValue(configKey, organizationId).then(({
      body = {}
    } = {}) => {
      !this.props.isPublic && this.props.onDownloadFile(body.fileUrl)
      this.props.autoDownload && this.handleOpenFile(body.fileUrl)
    })
  }

  handleOpenFile = (fileUrl, type, file) => {
    const { configuration, configKey } = this.props

    const fileName =
      get(file, 'name') ||
      get(
        configuration,
        `values[${configKey}].configurationKey.translatedDescription`
      )
    const link = document.createElement('a')

    document.body.appendChild(link)
    link.download = `${fileName}.${type}`
    link.target = '_blank'
    link.href = fileUrl

    link.click()
  }

  render() {
    const {
      configuration,
      configKey,
      files,
      downloadedFile,
      formattedName,
      inline,
      isPublic,
      autoDownload
    } = this.props
    const documentUrl = get(configuration, `values[${configKey}].fileUrl`)
    const file = files[documentUrl]
    const fileUrl = get(files[documentUrl], 'fileLocalUrl') || downloadedFile
    const type = get(files[documentUrl], 'type') || ''
    const loading = get(files[documentUrl], 'loading')
    const configFileStyles = inline
      ? { marginBottom: 0, display: 'inline', marginRight: 10 }
      : { marginBottom: 20 }

    return (
      <div style={configFileStyles}>
        {autoDownload &&
          <div className="text--center">
            <Span intlKey="label.if_your_download_doesnt_start">
              If your download doesn't start automatically please click this
            </Span>{' '}
            <a
              href={documentUrl}
              target="_blank"
              style={{ fontSize: '1em' }}
              className="link underline"
            >
              <FormattedMessage id="label.link" defaultMessage="link" />
            </a>
          </div>}

        {isPublic &&
          !autoDownload &&
          documentUrl &&
          <a
            href={documentUrl}
            target="_blank"
            className="link underline text-smaller"
          >
            {formattedName}
          </a>}

        {isPublic &&
          !autoDownload &&
          !documentUrl &&
          <span>
            <FormattedMessage
              id="label.file_is_not_available"
              defaultMessage="File is not available"
            />
          </span>}

        {!isPublic &&
          !autoDownload &&
          <div>
            {!fileUrl &&
              <span
                className="link underline text-smaller"
                onClick={this.handleRequestDownload}
              >
                {formattedName}
              </span>}

            <FileThumb
              type={type}
              file={file}
              fileUrl={fileUrl}
              originUrl={documentUrl}
              onClick={this.handleOpenFile}
              loading={loading}
              autodownload
              formattedName={
                <span
                  className="link underline text-smaller"
                  onClick={this.handleRequestDownload}
                >
                  {formattedName}
                </span>
              }
              simple
            />
          </div>}
      </div>
    )
  }
}

export default enhance(ConfigurationFile)
